export default __webpack_public_path__ + "a4c851c78e13bfe958916326742de42b.svg";